export const bannerData = [
  {
    id: "1",
    title: "BeeNow",
    img: [
      "beenow/style-1-1000x1000.png",
      "beenow/style-1-1000x2000.png",
      "beenow/style-2-1000x1000.png",
      "beenow/style-2-1000x2000-1.png",
      "beenow/style-2-1000x2000-2.png",
      "beenow/google-ads.png",
    ],
  },
];
